import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LayoutComponent } from './layouts/layout/layout.component';
import { StatusPageComponent } from './shared/components/status-page/status-page.component';

const routes: Routes = [
  {path: 'status', component: StatusPageComponent},
  // tslint:disable-next-line: max-line-length
  { path: '',  loadChildren: () => import('./frontend/frontend.module').then(m => m.FrontendModule)},
  { path: 'customer', component: LayoutComponent, loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
